var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"kt-menu__nav pt-0"},[_vm._l((_vm.menuItems),function(menu,i){return [(!menu.section)?_c('KTMenuItem',{key:i,attrs:{"menu":menu}}):_vm._e(),(menu.section)?_c('KTMenuSection',{key:i,attrs:{"menu":menu}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }